module.exports = __webpack_public_path__ + "static/media/raffle-btn@2x.40a3000f.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_230/imgs/raffle-btn@2x.png
// module id = 1762
// module chunks = 0